import { InfoCard, Avatar, Caption, Slot } from '@costar-ui/components';
import React from 'react';
import SocialIconLinks from '../../social-icon-links/social-icon-links.esm.js';
import { Name } from '../../card-details/name.esm.js';
import { JobTitle } from '../../card-details/job-title.esm.js';
import { Phone } from '../../card-details/phone.esm.js';
import { MailtoLink } from '../../card-details/mailto-link.esm.js';

var ContactCardSectionGhostDense = function ContactCardSectionGhostDense(props) {
  var photo = props.photo,
    excludePhoto = props.excludePhoto,
    name = props.name,
    jobTitle = props.jobTitle,
    phone = props.phone,
    mailtoLink = props.mailtoLink,
    socialIconLinks = props.socialIconLinks,
    isLoading = props.isLoading,
    testId = props.testId,
    responsive = props.responsive;
  return /*#__PURE__*/React.createElement(InfoCard, {
    variant: "ghost-dense",
    className: "csg-tw-contact-card-section-ghost-dense",
    testId: testId,
    responsive: responsive
  }, !excludePhoto && /*#__PURE__*/React.createElement(Avatar, {
    size: "md",
    src: photo === null || photo === void 0 ? void 0 : photo.src,
    title: name === null || name === void 0 ? void 0 : name.label,
    alt: name === null || name === void 0 ? void 0 : name.label,
    testId: "contact-image"
  }), /*#__PURE__*/React.createElement(Caption, {
    testId: "contact-details",
    responsive: responsive
  }, /*#__PURE__*/React.createElement(Name, {
    label: name === null || name === void 0 ? void 0 : name.label,
    href: name === null || name === void 0 ? void 0 : name.href,
    onNameClick: name === null || name === void 0 ? void 0 : name.onNameClick,
    isLoading: isLoading,
    testId: "contact-name"
  }), /*#__PURE__*/React.createElement(JobTitle, {
    label: jobTitle === null || jobTitle === void 0 ? void 0 : jobTitle.label,
    isLoading: isLoading,
    testId: "contact-job-title"
  }), /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "xs",
    testId: "contact-credentials"
  }, /*#__PURE__*/React.createElement(Phone, {
    labels: phone.labels,
    numbers: phone === null || phone === void 0 ? void 0 : phone.numbers,
    isLoading: isLoading,
    skeletonCount: 1,
    testId: "contact-phone-numbers"
  }), /*#__PURE__*/React.createElement(MailtoLink, {
    email: mailtoLink === null || mailtoLink === void 0 ? void 0 : mailtoLink.email,
    isLoading: isLoading,
    testId: "contact-mail-to-link"
  })), /*#__PURE__*/React.createElement(SocialIconLinks, {
    onEmailClick: socialIconLinks === null || socialIconLinks === void 0 ? void 0 : socialIconLinks.onEmailClick,
    vCard: socialIconLinks === null || socialIconLinks === void 0 ? void 0 : socialIconLinks.vCard,
    linkedInProfile: socialIconLinks === null || socialIconLinks === void 0 ? void 0 : socialIconLinks.linkedInProfile,
    isLoading: isLoading,
    testId: "contact-social-icon-links"
  })));
};
var ContactCardSectionGhostDense$1 = ContactCardSectionGhostDense;

export { ContactCardSectionGhostDense, ContactCardSectionGhostDense$1 as default };
//# sourceMappingURL=contact-card-section-ghost-dense.esm.js.map
